import { Typography } from '@mui/material';
import { ConnectorAuditLog } from '@oxappsec/ox-unified-audit-logger';
import { FC } from 'react';
import InfoItem from '../InfoItem';

const ConnectorsCard: FC<React.PropsWithChildren<ConnectorsCardProps>> = ({
  auditLog,
}) => {
  return (
    <>
      <InfoItem
        name='Connector'
        data={
          <Typography variant='body2' color='text.primary'>
            {auditLog.connector}
          </Typography>
        }
      />
      {auditLog.credentialsType && (
        <InfoItem
          name='Credentials Type'
          data={
            <Typography variant='body2' color='text.primary'>
              {auditLog.credentialsType}
            </Typography>
          }
        />
      )}
    </>
  );
};

export interface ConnectorsCardProps {
  auditLog: ConnectorAuditLog;
}

export default ConnectorsCard;
